/* eslint-disable no-underscore-dangle */
import React, { useEffect, useRef, useState } from 'react';
import { Box, LinearProgress, Theme } from '@quillbot/design-system';
import { makeStyles } from '@quillbot/design-system';
import { theme } from 'config/theme';
import getConfig from 'next/config';

const { publicRuntimeConfig } = getConfig();

const useStyles = makeStyles<Theme>(() => ({
  progressRoot: {
    height: 12,
    backgroundColor: theme.specialColors.SKELETON,
  },
  progressBar: {
    backgroundColor: theme.palette.background.default,
  },
}));

const estimateIntervalTimer: any = {};
let scanIntervalTimer: any;

const LinearLoader = () => {
  const classes = useStyles();

  return (
    <LinearProgress
      color="primary"
      classes={{
        root: classes.progressRoot,
        bar: classes.progressBar,
      }}
    />
  );
};

export default LinearLoader;
